<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        
        @click="getDate()"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入uid"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">hashId</label>
        <el-input
          v-model="hashId"
          placeholder="请输入hashId"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">转出地址</label>
        <el-input
          v-model="fromAddress"
          placeholder="请输入转出地址"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">国家地区</label>
        <el-input
          v-model="ipAddress"
          placeholder="请输入国家地区"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号类型</label>
        <el-select
          v-model="mcusername"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="主账号" :value="0"></el-option>
          <el-option label="子账号" :value="1"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值次数=</label>
        <el-input
          v-model="trc"
          placeholder="充值次数"
          style="width: 90px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值通道</label>
        <el-select
          v-model="transferType"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="BEP20" value="BEP20"></el-option>
          <el-option label="TRC20" value="TRC20"></el-option>
          <el-option label="ERC20" value="ERC20"></el-option>
          <el-option label="Polygon PoS" value="Polygon PoS"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值地址</label>
        <el-input
          v-model="toAddress"
          placeholder="请输入充值地址"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">ip</label>
        <el-input
          v-model="ip"
          placeholder="请输入ip"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>

      <div class="item_warp">
        <label style="margin: 0 10px">乙方</label>
        <el-input
          v-model="yifangUsername"
          placeholder="请输入乙方"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">注册至充值 =</label>
        <el-input
          v-model="rcday"
          placeholder="请输入天数"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值金额 > </label>
        <el-input
          v-model="minAmount"
          placeholder="请输入充值金额"
          style="width: 100px"
          size="mini"
          clearable
        />
       
      </div>
      
      <div class="item_warp">
        <label style="margin: 0 10px">时间</label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="flex: 1;"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">币安交易哈希</label>
        <el-input
          v-model="hashIds"
          placeholder="请输入币安智能链交易hashId"
          style="width: 220px"
          size="mini"
          clearable
        />
        <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="checkBnbHashId()"
        >检测</el-button
      >
      </div>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <div style="color: red">充值总金额：{{ totalRechargeCunt || 0 }}</div>
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1981px"
      size="mini"
    >
      <el-table-column prop="memberUid" label="用户" width="100" />
      <el-table-column prop="amount" label="充值金额" width="100" />
      <el-table-column prop="address" label="用户详情" width="230">
        <template slot-scope="scope">
          <div style="text-align: start;">
            <div>注册时间：{{ happenTimeFun(scope.row.myCreateDate) }}</div>
            <div>注册-充值：{{ scope.row.rcday }}天</div>
            <div>充值前资产：{{ scope.row.beforeAsset }}</div>
            <div>充值次数：{{ scope.row.trc }}次</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="上级" width="230">
        <template slot-scope="scope">
          <div style="text-align: start;">
            <div>UID：{{ scope.row.parentUid }}</div>
            <div>创建时间：{{ parentCreateDate(scope.row.parentCreateDate) }}天前</div>
            <div>下级：{{ scope.row.parentChildrenCount }}&nbsp;&nbsp;&nbsp;下级充值：{{ scope.row.parentVip1ChildCount }}</div>
            <div>上级IP：{{ scope.row.parentIp }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="IP" width="200">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.ip }}</div>
            <div>{{ scope.row.ipAddress }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="IP" width="100">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.act == 0">主账号</div>
            <div v-if="scope.row.act == 1">子账号</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="yifangUsername" label="乙方" width="100" />
      <el-table-column prop="fromAddress" label="转出地址" width="200" />
      <el-table-column prop="toAddress" label="充值地址" width="200" />
      <el-table-column prop="hashId" label="hashid" width="280" />
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="transferType" label="通道" width="150" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <div>
      <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加
      uid: "",
      hashId: "",
      hashIds:"",
      ipAddress:"",
      mcusername:"",
      fromAddress: "",
      toAddress: "",
      ip: "",
      yifangUsername: "",
      rcday: "",
      trc: "",
      dataTime: ["", ""],
      totalRechargeCunt: 0,
      transferType:"",
      minAmount:""
    };
  },
  mounted() {
    this.getDate();
  },
  methods: {
    happenTimeFun (num) {
	let date = new Date(num);
	//时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM; //月补0
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d; //天补0
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h; //小时补0
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m; //分钟补0
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s; //秒补0
	return y + '-' + MM + '-' + d;
},
parentCreateDate(tme){
   // 定义目标日期
const targetDate = new Date(tme);
// 获取当前日期和目标日期的毫秒数
const currentDate = new Date();
const targetDateMs = targetDate.getTime();
const currentDateMs = currentDate.getTime();
// 计算两个日期之间的毫秒差
const diffMs = currentDateMs - targetDateMs;
const daysDiff = (diffMs / (1000 * 60 * 60 * 24)).toFixed(0)
let daysDiff1 = parseInt(daysDiff)+1
return daysDiff1
},
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
      this.totalRecharge();
    },
    getDate() {
      this.getList();
      this.totalRecharge();
    },
    totalRecharge() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        hashId: this.hashId,
        fromAddress: this.fromAddress,
        toAddress: this.toAddress,
        ipAddress: this.ipAddress,
        act: this.mcusername,
        transferType: this.transferType,
        minAmount: this.minAmount,
        ip: this.ip,
        yifangUsername: this.yifangUsername,
        trc: this.trc,
        rcday: this.rcday,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .totalRecharge(params)
        .then((res) => {
          this.totalRechargeCunt = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        hashId: this.hashId,
        fromAddress: this.fromAddress,
        toAddress: this.toAddress,
        ip: this.ip,
        minAmount: this.minAmount,
        yifangUsername: this.yifangUsername,
        ipAddress: this.ipAddress,
        transferType: this.transferType,
        act: this.mcusername,
        trc: this.trc,
        rcday: this.rcday,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .tronsCanTransferList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
          // this.total = 10000;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkBnbHashId() {
      var params = {
        hashId: this.hashIds
      };
      this.$api.operate
        .checkBnbHashId(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .el-pagination{
  white-space: normal !important;

}

.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
